import { useLayoutEffect, useRef } from "react";

// This implementation comes from a PR for react-use that hasn't
// been merged yet.
// https://github.com/streamich/react-use/pull/2509
const useLatestRef = <T>(value: T): { readonly current: T } => {
  const ref = useRef(value);
  useLayoutEffect(() => {
    ref.current = value;
  });
  return ref;
};

export default useLatestRef;
